export const useAppVersion = (): string => {
  return __APP_VERSION__;
};
